import { z } from 'zod';

export const createUpsellItemSchema = z.object({
  name: z.string(),
  description: z.string().optional(),
  maxQuantityPerCart: z.number().optional(),
  price: z.number(),
  taxable: z.boolean(),
  photo: z
    .object({
      fileId: z.uuid(),
      url: z.string(),
      type: z.string(),
      notes: z.string(),
    })
    .optional()
    .nullable(),
});

export const updateUpsellItemSchema = z.object({
  id: z.uuid(),
  fieldsToUpdate: createUpsellItemSchema.partial().extend({
    archivedAtTs: z.string().nullish().optional(),
    photoId: z.string().nullish().optional(),
  }),
});

export const deleteUpsellItemPhotoSchema = z.object({
  id: z.uuid(),
  upsellItemId: z.uuid(),
});

export const submitUpsellItemsSchema = z.object({
  cartId: z.uuid(),
  tenantId: z.uuid(),
  items: z.array(
    z.object({
      upsellItemId: z.uuid(),
      quantity: z.number().min(1),
    }),
  ),
  isWebsite: z.boolean().optional().default(false),
});

export type CreateUpsellItemType = z.infer<typeof createUpsellItemSchema>;
export type UpdateUpsellItemType = z.infer<typeof updateUpsellItemSchema>;
export type DeleteUpsellItemPhotoType = z.infer<
  typeof deleteUpsellItemPhotoSchema
>;
